import * as Types from '../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EpocusProgramConfigQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
}>;


export type EpocusProgramConfigQuery = { readonly __typename?: 'Query', readonly programConfig?: { readonly __typename?: 'EpocusProgramConfig', readonly id: string, readonly worksheetSet: Types.EpocusWorksheetSet, readonly clinicalSetting: Types.EpocusProgramClinicalSetting, readonly billingModifierOverride?: Types.EpocusBillingModifierOverride | null, readonly enabledExamTypes: ReadonlyArray<Types.EpocusExamType>, readonly enabledDeviceIds: ReadonlyArray<string>, readonly billingRecipientName?: string | null, readonly billingRecipientEmail?: string | null, readonly billingDeliveryMethod: Types.EpocusBillingDeliveryMethod, readonly billingEndOfDayTime?: string | null, readonly postalCode?: string | null, readonly timezone: string, readonly reminderEmailTime: string, readonly medicareLocality?: { readonly __typename?: 'EpocusMedicareLocality', readonly carrier: string, readonly locality: string, readonly name?: string | null, readonly state?: string | null, readonly spansLocalities: boolean } | null } | null };

export type EpocusMedicareLocalityFieldsFragment = { readonly __typename?: 'EpocusMedicareLocality', readonly carrier: string, readonly locality: string, readonly name?: string | null, readonly state?: string | null, readonly spansLocalities: boolean };

export type EpocusDeviceCatalogueQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type EpocusDeviceCatalogueQuery = { readonly __typename?: 'Query', readonly epocusDeviceCatalogue: ReadonlyArray<{ readonly __typename?: 'EpocusDevice', readonly id: string, readonly model: string, readonly vendor: string, readonly formFactor: Types.EpocusDeviceFormFactor }> };

export type EpocusSetProgramEnabledExamTypesMutationVariables = Types.Exact<{
  input: Types.SetEpocusProgramEnabledExamTypesInput;
}>;


export type EpocusSetProgramEnabledExamTypesMutation = { readonly __typename?: 'Mutation', readonly setEpocusProgramEnabledExamTypes: { readonly __typename?: 'EpocusProgram', readonly id: string, readonly config?: { readonly __typename?: 'EpocusProgramConfig', readonly id: string, readonly enabledExamTypes: ReadonlyArray<Types.EpocusExamType> } | null } };

export type EpocusUpdateProgramSetupMutationVariables = Types.Exact<{
  input: Types.UpdateEpocusProgramInput;
}>;


export type EpocusUpdateProgramSetupMutation = { readonly __typename?: 'Mutation', readonly updateEpocusProgram: { readonly __typename?: 'EpocusProgram', readonly id: string, readonly config?: { readonly __typename?: 'EpocusProgramConfig', readonly id: string, readonly worksheetSet: Types.EpocusWorksheetSet, readonly clinicalSetting: Types.EpocusProgramClinicalSetting, readonly billingModifierOverride?: Types.EpocusBillingModifierOverride | null, readonly postalCode?: string | null, readonly timezone: string, readonly reminderEmailTime: string, readonly medicareLocality?: { readonly __typename?: 'EpocusMedicareLocality', readonly carrier: string, readonly locality: string, readonly name?: string | null, readonly state?: string | null, readonly spansLocalities: boolean } | null } | null } };

export type EpocusSetProgramEnabledDeviceIdsMutationVariables = Types.Exact<{
  input: Types.SetEpocusProgramEnabledDeviceIdsInput;
}>;


export type EpocusSetProgramEnabledDeviceIdsMutation = { readonly __typename?: 'Mutation', readonly setEpocusProgramEnabledDeviceIds: { readonly __typename?: 'EpocusProgram', readonly id: string, readonly config?: { readonly __typename?: 'EpocusProgramConfig', readonly id: string, readonly enabledDeviceIds: ReadonlyArray<string> } | null } };

export type EpocusWorklistEntryFragment = { readonly __typename?: 'EpocusProgramWorklistEntry', readonly encounterId: string, readonly accessionNumber: string, readonly patientName?: string | null, readonly patientMrn?: string | null, readonly scheduledStart?: string | null, readonly requestedExamType?: string | null, readonly requestPriority?: Types.EpocusRequestPriority | null, readonly requestNotes?: string | null, readonly indication?: string | null, readonly performerId?: string | null, readonly isTestScan: boolean };

export type EpocusProgramWorklistQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
}>;


export type EpocusProgramWorklistQuery = { readonly __typename?: 'Query', readonly epocusProgramWorklist: ReadonlyArray<{ readonly __typename?: 'EpocusProgramWorklistEntry', readonly encounterId: string, readonly accessionNumber: string, readonly patientName?: string | null, readonly patientMrn?: string | null, readonly scheduledStart?: string | null, readonly requestedExamType?: string | null, readonly requestPriority?: Types.EpocusRequestPriority | null, readonly requestNotes?: string | null, readonly indication?: string | null, readonly performerId?: string | null, readonly isTestScan: boolean }> };

export type EpocusSeedWorklistMutationVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
  count: Types.Scalars['Int'];
}>;


export type EpocusSeedWorklistMutation = { readonly __typename?: 'Mutation', readonly seedEpocusWorklist: { readonly __typename?: 'EpocusSeededWorklistResult', readonly programId: string, readonly cancelledCount: number, readonly entries: ReadonlyArray<{ readonly __typename?: 'EpocusProgramWorklistEntry', readonly encounterId: string, readonly accessionNumber: string, readonly patientName?: string | null, readonly patientMrn?: string | null, readonly scheduledStart?: string | null, readonly requestedExamType?: string | null, readonly requestPriority?: Types.EpocusRequestPriority | null, readonly requestNotes?: string | null, readonly indication?: string | null, readonly performerId?: string | null, readonly isTestScan: boolean }> } };

export type EpocusClearSeededWorklistMutationVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
}>;


export type EpocusClearSeededWorklistMutation = { readonly __typename?: 'Mutation', readonly clearEpocusSeededWorklist: { readonly __typename?: 'EpocusSeededWorklistResult', readonly programId: string, readonly cancelledCount: number, readonly entries: ReadonlyArray<{ readonly __typename?: 'EpocusProgramWorklistEntry', readonly encounterId: string, readonly accessionNumber: string, readonly patientName?: string | null, readonly patientMrn?: string | null, readonly scheduledStart?: string | null, readonly requestedExamType?: string | null, readonly requestPriority?: Types.EpocusRequestPriority | null, readonly requestNotes?: string | null, readonly indication?: string | null, readonly performerId?: string | null, readonly isTestScan: boolean }> } };

export type EpocusUpdateProgramBillingRecipientMutationVariables = Types.Exact<{
  input: Types.UpdateEpocusProgramInput;
}>;


export type EpocusUpdateProgramBillingRecipientMutation = { readonly __typename?: 'Mutation', readonly updateEpocusProgram: { readonly __typename?: 'EpocusProgram', readonly id: string, readonly config?: { readonly __typename?: 'EpocusProgramConfig', readonly id: string, readonly billingRecipientName?: string | null, readonly billingRecipientEmail?: string | null, readonly billingDeliveryMethod: Types.EpocusBillingDeliveryMethod, readonly billingEndOfDayTime?: string | null } | null } };

export const EpocusMedicareLocalityFieldsFragmentDoc = gql`
    fragment EpocusMedicareLocalityFields on EpocusMedicareLocality {
  carrier
  locality
  name
  state
  spansLocalities
}
    `;
export const EpocusWorklistEntryFragmentDoc = gql`
    fragment EpocusWorklistEntry on EpocusProgramWorklistEntry {
  encounterId
  accessionNumber
  patientName
  patientMrn
  scheduledStart
  requestedExamType
  requestPriority
  requestNotes
  indication
  performerId
  isTestScan
}
    `;
export const EpocusProgramConfigDocument = gql`
    query EpocusProgramConfig($programId: ID!) {
  programConfig(programId: $programId) {
    id
    worksheetSet
    clinicalSetting
    billingModifierOverride
    enabledExamTypes
    enabledDeviceIds
    billingRecipientName
    billingRecipientEmail
    billingDeliveryMethod
    billingEndOfDayTime
    postalCode
    medicareLocality {
      ...EpocusMedicareLocalityFields
    }
    timezone
    reminderEmailTime
  }
}
    ${EpocusMedicareLocalityFieldsFragmentDoc}`;

/**
 * __useEpocusProgramConfigQuery__
 *
 * To run a query within a React component, call `useEpocusProgramConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusProgramConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusProgramConfigQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useEpocusProgramConfigQuery(baseOptions: Apollo.QueryHookOptions<EpocusProgramConfigQuery, EpocusProgramConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusProgramConfigQuery, EpocusProgramConfigQueryVariables>(EpocusProgramConfigDocument, options);
      }
export function useEpocusProgramConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusProgramConfigQuery, EpocusProgramConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusProgramConfigQuery, EpocusProgramConfigQueryVariables>(EpocusProgramConfigDocument, options);
        }
export type EpocusProgramConfigQueryHookResult = ReturnType<typeof useEpocusProgramConfigQuery>;
export type EpocusProgramConfigLazyQueryHookResult = ReturnType<typeof useEpocusProgramConfigLazyQuery>;
export type EpocusProgramConfigQueryResult = Apollo.QueryResult<EpocusProgramConfigQuery, EpocusProgramConfigQueryVariables>;
export const EpocusDeviceCatalogueDocument = gql`
    query EpocusDeviceCatalogue {
  epocusDeviceCatalogue {
    id
    model
    vendor
    formFactor
  }
}
    `;

/**
 * __useEpocusDeviceCatalogueQuery__
 *
 * To run a query within a React component, call `useEpocusDeviceCatalogueQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusDeviceCatalogueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusDeviceCatalogueQuery({
 *   variables: {
 *   },
 * });
 */
export function useEpocusDeviceCatalogueQuery(baseOptions?: Apollo.QueryHookOptions<EpocusDeviceCatalogueQuery, EpocusDeviceCatalogueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusDeviceCatalogueQuery, EpocusDeviceCatalogueQueryVariables>(EpocusDeviceCatalogueDocument, options);
      }
export function useEpocusDeviceCatalogueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusDeviceCatalogueQuery, EpocusDeviceCatalogueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusDeviceCatalogueQuery, EpocusDeviceCatalogueQueryVariables>(EpocusDeviceCatalogueDocument, options);
        }
export type EpocusDeviceCatalogueQueryHookResult = ReturnType<typeof useEpocusDeviceCatalogueQuery>;
export type EpocusDeviceCatalogueLazyQueryHookResult = ReturnType<typeof useEpocusDeviceCatalogueLazyQuery>;
export type EpocusDeviceCatalogueQueryResult = Apollo.QueryResult<EpocusDeviceCatalogueQuery, EpocusDeviceCatalogueQueryVariables>;
export const EpocusSetProgramEnabledExamTypesDocument = gql`
    mutation EpocusSetProgramEnabledExamTypes($input: SetEpocusProgramEnabledExamTypesInput!) {
  setEpocusProgramEnabledExamTypes(input: $input) {
    id
    config {
      id
      enabledExamTypes
    }
  }
}
    `;
export type EpocusSetProgramEnabledExamTypesMutationFn = Apollo.MutationFunction<EpocusSetProgramEnabledExamTypesMutation, EpocusSetProgramEnabledExamTypesMutationVariables>;

/**
 * __useEpocusSetProgramEnabledExamTypesMutation__
 *
 * To run a mutation, you first call `useEpocusSetProgramEnabledExamTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEpocusSetProgramEnabledExamTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [epocusSetProgramEnabledExamTypesMutation, { data, loading, error }] = useEpocusSetProgramEnabledExamTypesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEpocusSetProgramEnabledExamTypesMutation(baseOptions?: Apollo.MutationHookOptions<EpocusSetProgramEnabledExamTypesMutation, EpocusSetProgramEnabledExamTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EpocusSetProgramEnabledExamTypesMutation, EpocusSetProgramEnabledExamTypesMutationVariables>(EpocusSetProgramEnabledExamTypesDocument, options);
      }
export type EpocusSetProgramEnabledExamTypesMutationHookResult = ReturnType<typeof useEpocusSetProgramEnabledExamTypesMutation>;
export type EpocusSetProgramEnabledExamTypesMutationResult = Apollo.MutationResult<EpocusSetProgramEnabledExamTypesMutation>;
export type EpocusSetProgramEnabledExamTypesMutationOptions = Apollo.BaseMutationOptions<EpocusSetProgramEnabledExamTypesMutation, EpocusSetProgramEnabledExamTypesMutationVariables>;
export const EpocusUpdateProgramSetupDocument = gql`
    mutation EpocusUpdateProgramSetup($input: UpdateEpocusProgramInput!) {
  updateEpocusProgram(input: $input) {
    id
    config {
      id
      worksheetSet
      clinicalSetting
      billingModifierOverride
      postalCode
      medicareLocality {
        ...EpocusMedicareLocalityFields
      }
      timezone
      reminderEmailTime
    }
  }
}
    ${EpocusMedicareLocalityFieldsFragmentDoc}`;
export type EpocusUpdateProgramSetupMutationFn = Apollo.MutationFunction<EpocusUpdateProgramSetupMutation, EpocusUpdateProgramSetupMutationVariables>;

/**
 * __useEpocusUpdateProgramSetupMutation__
 *
 * To run a mutation, you first call `useEpocusUpdateProgramSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEpocusUpdateProgramSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [epocusUpdateProgramSetupMutation, { data, loading, error }] = useEpocusUpdateProgramSetupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEpocusUpdateProgramSetupMutation(baseOptions?: Apollo.MutationHookOptions<EpocusUpdateProgramSetupMutation, EpocusUpdateProgramSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EpocusUpdateProgramSetupMutation, EpocusUpdateProgramSetupMutationVariables>(EpocusUpdateProgramSetupDocument, options);
      }
export type EpocusUpdateProgramSetupMutationHookResult = ReturnType<typeof useEpocusUpdateProgramSetupMutation>;
export type EpocusUpdateProgramSetupMutationResult = Apollo.MutationResult<EpocusUpdateProgramSetupMutation>;
export type EpocusUpdateProgramSetupMutationOptions = Apollo.BaseMutationOptions<EpocusUpdateProgramSetupMutation, EpocusUpdateProgramSetupMutationVariables>;
export const EpocusSetProgramEnabledDeviceIdsDocument = gql`
    mutation EpocusSetProgramEnabledDeviceIds($input: SetEpocusProgramEnabledDeviceIdsInput!) {
  setEpocusProgramEnabledDeviceIds(input: $input) {
    id
    config {
      id
      enabledDeviceIds
    }
  }
}
    `;
export type EpocusSetProgramEnabledDeviceIdsMutationFn = Apollo.MutationFunction<EpocusSetProgramEnabledDeviceIdsMutation, EpocusSetProgramEnabledDeviceIdsMutationVariables>;

/**
 * __useEpocusSetProgramEnabledDeviceIdsMutation__
 *
 * To run a mutation, you first call `useEpocusSetProgramEnabledDeviceIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEpocusSetProgramEnabledDeviceIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [epocusSetProgramEnabledDeviceIdsMutation, { data, loading, error }] = useEpocusSetProgramEnabledDeviceIdsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEpocusSetProgramEnabledDeviceIdsMutation(baseOptions?: Apollo.MutationHookOptions<EpocusSetProgramEnabledDeviceIdsMutation, EpocusSetProgramEnabledDeviceIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EpocusSetProgramEnabledDeviceIdsMutation, EpocusSetProgramEnabledDeviceIdsMutationVariables>(EpocusSetProgramEnabledDeviceIdsDocument, options);
      }
export type EpocusSetProgramEnabledDeviceIdsMutationHookResult = ReturnType<typeof useEpocusSetProgramEnabledDeviceIdsMutation>;
export type EpocusSetProgramEnabledDeviceIdsMutationResult = Apollo.MutationResult<EpocusSetProgramEnabledDeviceIdsMutation>;
export type EpocusSetProgramEnabledDeviceIdsMutationOptions = Apollo.BaseMutationOptions<EpocusSetProgramEnabledDeviceIdsMutation, EpocusSetProgramEnabledDeviceIdsMutationVariables>;
export const EpocusProgramWorklistDocument = gql`
    query EpocusProgramWorklist($programId: ID!) {
  epocusProgramWorklist(programId: $programId) {
    ...EpocusWorklistEntry
  }
}
    ${EpocusWorklistEntryFragmentDoc}`;

/**
 * __useEpocusProgramWorklistQuery__
 *
 * To run a query within a React component, call `useEpocusProgramWorklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusProgramWorklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusProgramWorklistQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useEpocusProgramWorklistQuery(baseOptions: Apollo.QueryHookOptions<EpocusProgramWorklistQuery, EpocusProgramWorklistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusProgramWorklistQuery, EpocusProgramWorklistQueryVariables>(EpocusProgramWorklistDocument, options);
      }
export function useEpocusProgramWorklistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusProgramWorklistQuery, EpocusProgramWorklistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusProgramWorklistQuery, EpocusProgramWorklistQueryVariables>(EpocusProgramWorklistDocument, options);
        }
export type EpocusProgramWorklistQueryHookResult = ReturnType<typeof useEpocusProgramWorklistQuery>;
export type EpocusProgramWorklistLazyQueryHookResult = ReturnType<typeof useEpocusProgramWorklistLazyQuery>;
export type EpocusProgramWorklistQueryResult = Apollo.QueryResult<EpocusProgramWorklistQuery, EpocusProgramWorklistQueryVariables>;
export const EpocusSeedWorklistDocument = gql`
    mutation EpocusSeedWorklist($programId: ID!, $count: Int!) {
  seedEpocusWorklist(programId: $programId, count: $count) {
    programId
    cancelledCount
    entries {
      ...EpocusWorklistEntry
    }
  }
}
    ${EpocusWorklistEntryFragmentDoc}`;
export type EpocusSeedWorklistMutationFn = Apollo.MutationFunction<EpocusSeedWorklistMutation, EpocusSeedWorklistMutationVariables>;

/**
 * __useEpocusSeedWorklistMutation__
 *
 * To run a mutation, you first call `useEpocusSeedWorklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEpocusSeedWorklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [epocusSeedWorklistMutation, { data, loading, error }] = useEpocusSeedWorklistMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useEpocusSeedWorklistMutation(baseOptions?: Apollo.MutationHookOptions<EpocusSeedWorklistMutation, EpocusSeedWorklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EpocusSeedWorklistMutation, EpocusSeedWorklistMutationVariables>(EpocusSeedWorklistDocument, options);
      }
export type EpocusSeedWorklistMutationHookResult = ReturnType<typeof useEpocusSeedWorklistMutation>;
export type EpocusSeedWorklistMutationResult = Apollo.MutationResult<EpocusSeedWorklistMutation>;
export type EpocusSeedWorklistMutationOptions = Apollo.BaseMutationOptions<EpocusSeedWorklistMutation, EpocusSeedWorklistMutationVariables>;
export const EpocusClearSeededWorklistDocument = gql`
    mutation EpocusClearSeededWorklist($programId: ID!) {
  clearEpocusSeededWorklist(programId: $programId) {
    programId
    cancelledCount
    entries {
      ...EpocusWorklistEntry
    }
  }
}
    ${EpocusWorklistEntryFragmentDoc}`;
export type EpocusClearSeededWorklistMutationFn = Apollo.MutationFunction<EpocusClearSeededWorklistMutation, EpocusClearSeededWorklistMutationVariables>;

/**
 * __useEpocusClearSeededWorklistMutation__
 *
 * To run a mutation, you first call `useEpocusClearSeededWorklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEpocusClearSeededWorklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [epocusClearSeededWorklistMutation, { data, loading, error }] = useEpocusClearSeededWorklistMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useEpocusClearSeededWorklistMutation(baseOptions?: Apollo.MutationHookOptions<EpocusClearSeededWorklistMutation, EpocusClearSeededWorklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EpocusClearSeededWorklistMutation, EpocusClearSeededWorklistMutationVariables>(EpocusClearSeededWorklistDocument, options);
      }
export type EpocusClearSeededWorklistMutationHookResult = ReturnType<typeof useEpocusClearSeededWorklistMutation>;
export type EpocusClearSeededWorklistMutationResult = Apollo.MutationResult<EpocusClearSeededWorklistMutation>;
export type EpocusClearSeededWorklistMutationOptions = Apollo.BaseMutationOptions<EpocusClearSeededWorklistMutation, EpocusClearSeededWorklistMutationVariables>;
export const EpocusUpdateProgramBillingRecipientDocument = gql`
    mutation EpocusUpdateProgramBillingRecipient($input: UpdateEpocusProgramInput!) {
  updateEpocusProgram(input: $input) {
    id
    config {
      id
      billingRecipientName
      billingRecipientEmail
      billingDeliveryMethod
      billingEndOfDayTime
    }
  }
}
    `;
export type EpocusUpdateProgramBillingRecipientMutationFn = Apollo.MutationFunction<EpocusUpdateProgramBillingRecipientMutation, EpocusUpdateProgramBillingRecipientMutationVariables>;

/**
 * __useEpocusUpdateProgramBillingRecipientMutation__
 *
 * To run a mutation, you first call `useEpocusUpdateProgramBillingRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEpocusUpdateProgramBillingRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [epocusUpdateProgramBillingRecipientMutation, { data, loading, error }] = useEpocusUpdateProgramBillingRecipientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEpocusUpdateProgramBillingRecipientMutation(baseOptions?: Apollo.MutationHookOptions<EpocusUpdateProgramBillingRecipientMutation, EpocusUpdateProgramBillingRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EpocusUpdateProgramBillingRecipientMutation, EpocusUpdateProgramBillingRecipientMutationVariables>(EpocusUpdateProgramBillingRecipientDocument, options);
      }
export type EpocusUpdateProgramBillingRecipientMutationHookResult = ReturnType<typeof useEpocusUpdateProgramBillingRecipientMutation>;
export type EpocusUpdateProgramBillingRecipientMutationResult = Apollo.MutationResult<EpocusUpdateProgramBillingRecipientMutation>;
export type EpocusUpdateProgramBillingRecipientMutationOptions = Apollo.BaseMutationOptions<EpocusUpdateProgramBillingRecipientMutation, EpocusUpdateProgramBillingRecipientMutationVariables>;